import React from 'react';
import myImage from '../img/myImage.png';

class About extends React.Component {
  constructor() {
    super();

    this.state = {
      codingSkills: [
        { id: 'java_skill', content: 'JAVA', porcentage: '0', value: '80' },
        {
          id: 'java_skill',
          content: 'JAVA SCRIPT',
          porcentage: '0',
          value: '80',
        },
        { id: 'java_skill', content: 'DART', porcentage: '0', value: '80' },
        { id: 'java_skill', content: 'SWIFT', porcentage: '0', value: '80' },
        { id: 'java_skill', content: 'C', porcentage: '0', value: '80' },
      ],
      mobileSkills: [
        {
          id: 'Flutter_skill',
          content: 'FLUTTER',
          porcentage: '0',
          value: '80',
        },
        {
          id: 'iOS_skill',
          content: 'iOS DEVELOPMENT',
          porcentage: '0',
          value: '80',
        },
        {
          id: 'RN_skill',
          content: 'REACT NATIVE',
          porcentage: '0',
          value: '80',
        },
      ],
      skills: [
        {
          id: 'ReactJS_skill',
          content: 'ReactJS',
          porcentage: '0',
          value: '80',
        },
        {
          id: 'NodeJS_skill',
          content: 'NodeJs/ExpressJs',
          porcentage: '0',
          value: '80',
        },
        { id: 'HTML5_skill', content: 'HTML5', porcentage: '0', value: '80' },
        { id: 'CSS3_skill', content: 'CSS3', porcentage: '0', value: '75' },
        {
          id: 'JavaScript_skill',
          content: 'JavaScript',
          porcentage: '0',
          value: '90',
        },
        {
          id: 'bootstrap_skill',
          content: 'Bootstrap',
          porcentage: '0',
          value: '80',
        },
        {
          id: 'mui_skill',
          content: 'Material-Ui',
          porcentage: '0',
          value: '80',
        },
      ],
      about_me: [
        {
          id: 'first-p-about',
          content:
            "I'm an energetic and passionate undergraduate with an outstanding and award winning performances. I'm expecting to utilize my skills and expertise to contribute my level best to your company with positive mindset.",
        },
        {
          id: 'second-p-about',
          content: 'Any Type Of Query & Discussion.',
        },
        {
          id: 'second-p-about',
          content: 'Late talk with me',
        },
        {
          id: 'third-p-about',
          content: 'deveenrath@gmail.com ',
        },
      ],
    };
  }

  render() {
    return (
      <section id='about' className='about-mf sect-pt4 route'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12'>
              <div className='box-shadow-full'>
                <div className='row'>
                  <div className='col-md-6'>
                    {/*<div className="row">*/}
                    {/*  <div*/}
                    {/*    className="col-sm-6 col-md-5"*/}
                    {/*    style={{ margin: "0 auto" }}*/}
                    {/*  >*/}
                    {/*    <div*/}
                    {/*      className="about-img"*/}
                    {/*      style={{ textAlign: "center" }}*/}
                    {/*    >*/}
                    {/*      <img*/}
                    {/*        className="img-fluid rounded b-shadow-a"*/}
                    {/*        alt=""*/}
                    {/*      />*/}
                    {/*    </div>*/}
                    {/*  </div>*/}
                    {/*</div>*/}
                    <div className='skill-mf'>
                      <p className='title-s'>Web Development</p>
                      {this.state.skills.map((skill) => {
                        return (
                          <React.Fragment key={skill.id}>
                            <span>{skill.content}</span>{' '}
                            {/*<span className="pull-right">*/}
                            {/*  {skill.porcentage}*/}
                            {/*</span>*/}
                            <div className='progress'>
                              <div
                                className='progress-bar'
                                role='progressbar'
                                style={{ width: skill.porcentage }}
                                aria-valuenow={skill.value}
                                aria-valuemin='0'
                                aria-valuemax='100'
                              />
                            </div>
                          </React.Fragment>
                        );
                      })}
                      <p className='title-s'>Mobile Development</p>
                      {this.state.mobileSkills.map((skill) => {
                        return (
                          <React.Fragment key={skill.id}>
                            <span>{skill.content}</span>{' '}
                            {/*  <span className="pull-right">*/}
                            {/*  {skill.porcentage}*/}
                            {/*</span>*/}
                            <div className='progress'>
                              <div
                                className='progress-bar'
                                role='progressbar'
                                style={{ width: skill.porcentage }}
                                aria-valuenow={skill.value}
                                aria-valuemin='0'
                                aria-valuemax='100'
                              />
                            </div>
                          </React.Fragment>
                        );
                      })}
                      <p className='title-s'>Programming Languages</p>
                      {this.state.codingSkills.map((skill) => {
                        return (
                          <React.Fragment key={skill.id}>
                            <span>{skill.content}</span>{' '}
                            {/*  <span className="pull-right">*/}
                            {/*  {skill.porcentage}*/}
                            {/*</span>*/}
                            <div className='progress'>
                              <div
                                className='progress-bar'
                                role='progressbar'
                                style={{ width: skill.porcentage }}
                                aria-valuenow={skill.value}
                                aria-valuemin='0'
                                aria-valuemax='100'
                              />
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='about-me pt-4 pt-md-0'>
                      <div className='title-box-2'>
                        <h5 className='title-left'>About Me</h5>
                      </div>
                      {this.state.about_me.map((content) => {
                        return (
                          <p className='lead' key={content.id}>
                            {content.content}
                          </p>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
